// extracted by mini-css-extract-plugin
export default {"step-row":"Lesson_step-row__+E8WZ","nested":"Lesson_nested__GMUzA","new-step-container":"Lesson_new-step-container__zONo6","avatar":"Lesson_avatar__t6KSk"};